module.exports = __webpack_public_path__ + "img/helmet_home.7445c224.png";